export default __webpack_public_path__ + "static/media/right-footed.00f03798.svg";